import { theme } from "config/theme";
import styled from "styled-components";

export const ParcelsBadgeContainer = styled("div")`
  display: block;
  justify-content: flex;
  width: fit-content;
  margin-left: auto;
  color: #f2994a;
`;

export const ParcelsBadgeButton = styled("div")`
  font-size: 8px;
  margin-top: 5px;
  display: flex;
  cursor: pointer;
  padding: 6px;
  background-color: #f2994a;
  color: #f2994a;
  border-radius: 4px;
  align-items: center;
  border: 0.5px solid #f2994a;
  border-radius: 100px;
  &:hover {
    background-color: #f6f6f6;
  }
`;

export interface parcelsCountProps {
  backgroundColor?: string;
  borderRadius?: string;
  padding?: string;
  color?: string;
  marginTop?: string;
  height?: string;
  width?: string;
}

export const ParcelsCount = styled("div")<parcelsCountProps>`
  font-size: 8px;
  margin-top: ${({ marginTop }) => marginTop || "14px"};
  margin-right: 10px;
  display: flex;
  cursor: pointer;
  height: ${({ height }) => height || "inherit"};
  width: ${({ width }) => width || "inherit"};
  color: ${({ color }) => color || "inherit"};
  padding: ${({ padding }) => padding || "6px"};
  border-radius: 4px;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor || "#f2994a"};
  border: 1px solid ${({ color }) => color || "#f2994a"};
  border-radius: ${({ borderRadius }) => borderRadius || "100px"};
  &:hover {
    background-color: ${({ backgroundColor }) => (backgroundColor && "none") || "#f2994a"};
  }
  ${theme.breakpoints.down("xs")} {
    margin-left: 185px;
    margin-top: -4px;
  }
`;

export const ParcelsBadgeText = styled("div")`
  font-size: 10pt;
  padding-left: 5px;
  font-weight: normal;
  background-color: #f2994a;
  color: #399ebf;
`;
export interface parcelsCountTextProps {
  color?: string;
}
export const ParcelsCountText = styled("div")`
  font-size: 9pt;
  font-weight: normal;
  padding-left: 5px;
  color: ${({ color }) => color || "#fff"};
`;

export const ContainerBadge = styled("div")`
  text-align: -webkit-right;
  .eDzxML {
    background-color: #f2994a;
  }
`;

export const ContainerTaskDetails = styled("div")`
  display: flex;
`;
